<template xmlns="http://www.w3.org/1999/html">
  <Toast />

  <div v-if="isLoggedIn" :class="shellClass">
    <!-- Backdrop mobile -->
    <Transition name="backdrop-fade">
      <div
        v-if="isMobileNavOpen"
        class="app-mobile-backdrop"
        @click="closeMobileNav"
      ></div>
    </Transition>

    <!-- Sidebar desktop -->
    <aside v-if="!isMobile" class="app-sidebar">
      <TopNavBar
        :isLoggedIn="isLoggedIn"
        :collapsed="isSidebarCollapsed"
        @toggleCollapse="toggleSidebarCollapsed"
      />
    </aside>

    <!-- Sidebar mobile (overlay, slide-in) -->
    <Transition name="sidebar-mobile">
      <aside v-if="isMobile && isMobileNavOpen" class="app-sidebar">
        <TopNavBar
          :isLoggedIn="isLoggedIn"
          :collapsed="false"
          @toggleCollapse="closeMobileNav"
          @navigate="closeMobileNav"
        />
      </aside>
    </Transition>

    <main class="app-main">
      <header class="app-topbar">
        <div class="app-topbar__left">
          <Button
            class="p-button-text"
            icon="pi pi-bars"
            aria-label="Menu"
            @click="onMenuClick"
          />
          <div class="app-topbar__title">QLTS Menu</div>
        </div>
        <div class="app-topbar__right">
          <div
            class="app-surface"
            style="display:flex;align-items:center;gap:10px;padding:6px 10px;border-radius:999px;"
          >
            <img
              src="./assets/bs2.png"
              alt="avatar"
              style="width:28px;height:28px;border-radius:999px;object-fit:cover;"
            />
            <div
              style="display:flex;flex-direction:column;line-height:1.1;max-width:240px;"
            >
              <span
                style="font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                >{{ fullName }}</span
              >
              <span
                style="font-size:12px;color:var(--app-muted);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                >{{ team }}</span
              >
            </div>
          </div>
        </div>
      </header>

      <section class="app-content">
        <div class="app-surface" style="padding: 14px;">
          <router-view />
        </div>
      </section>
    </main>
  </div>

  <div v-else class="app-content">
    <LoginPage />
  </div>
</template>

<!--<style lang="scss">-->
//.app-container { // margin: 0 auto; // max-width: 1400px; // width: 100%; //
height: inherit; // background: #F7F8F9; // .app-content { // margin: 8px; // }
//}
<!--</style>-->
<style lang="scss"></style>
<script>
import TopNavBar from "@/components/TopNavBar";
import LoginPage from "@/pages/LoginPage";
import { useStore } from "vuex";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";

export default {
  components: { TopNavBar, LoginPage },
  setup() {
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);
    const fullName = computed(() => store.state.fullName);
    const team = computed(() => store.state.team);
    const isSidebarCollapsed = ref(false);
    const isMobileNavOpen = ref(false);
    const isMobile = ref(false);

    const calcIsMobile = () => {
      isMobile.value =
        window.matchMedia && window.matchMedia("(max-width: 980px)").matches;
      if (!isMobile.value) isMobileNavOpen.value = false;
    };

    onMounted(() => {
      calcIsMobile();
      window.addEventListener("resize", calcIsMobile, { passive: true });
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", calcIsMobile);
    });

    const toggleSidebarCollapsed = () => {
      isSidebarCollapsed.value = !isSidebarCollapsed.value;
    };

    const closeMobileNav = () => {
      isMobileNavOpen.value = false;
    };

    const onMenuClick = () => {
      if (isMobile.value) isMobileNavOpen.value = !isMobileNavOpen.value;
      else toggleSidebarCollapsed();
    };

    const shellClass = computed(() => {
      const classes = ["app-shell"];
      if (isSidebarCollapsed.value && !isMobile.value)
        classes.push("app-shell--collapsed");
      if (isMobile.value && isMobileNavOpen.value)
        classes.push("app-shell--mobile");
      return classes.join(" ");
    });

    return {
      isLoggedIn,
      fullName,
      team,
      isSidebarCollapsed,
      toggleSidebarCollapsed,
      isMobileNavOpen,
      closeMobileNav,
      onMenuClick,
      isMobile,
      shellClass,
      noop: () => {},
    };
  },
};
</script>
